module.exports = { purchase: 'purchase', rent: 'rent' };
